export const cartReducer = (state, action) => {
    // console.log({ action });
    // console.log({ state });
    
    switch (action.type) {
        case "ADD_TO_CART":
            return { 
                ...state, 
                cart: [...state.cart, { ...action.payload, qty: 1 }] 
            };

        case "REMOVE_FROM_CART":
            return { 
                ...state, 
                cart: state.cart.filter(item => item.id !== action.payload.id) 
            };

        case "DECREMENT_FROM_CART":
            return { 
                ...state, 
                cart: state.cart.map(item =>
                    item.id === action.payload.id
                        ? { ...item, qty: Math.max(1, item.qty - 1) }
                        : item
                )
            };

        case "INCREMENT_TO_CART":
            return { 
                ...state, 
                cart: state.cart.map(item =>
                    item.id === action.payload.id
                        ? { ...item, qty: Math.min(999, item.qty + 1) }
                        : item
                )
            };

        case "HANDLE_QTY":
        case "HANDLE_KEY_UP_QTY":
            return { 
                ...state, 
                cart: state.cart.map(item =>
                    item.id === action.payload.id
                        ? { ...item, qty: Math.min(999, Math.max(1, Number(action.payload.qty))) }
                        : item
                )
            };

        default:
            return state;
    }
};
